var e=function(){return"undefined"!=typeof window&&"undefined"!=typeof document};export{e as isBrowser};
